/* TC reveal — cross-fade grey→colour on in-view (and hover on pointer devices).
   No library. Idempotent: safe if the script loads more than once. */
(function () {
  if (window.__tcRevealInit) return;
  window.__tcRevealInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) { el.classList.add('is-revealed'); }
  function unreveal(el) { el.classList.remove('is-revealed'); }

  function bind(el) {
    if (el.__tcBound) return;
    el.__tcBound = true;

    // Reduced motion: CSS already shows the sun state; nothing to animate.
    if (reduce) { reveal(el); return; }

    // Hover toggles the reveal on devices with a real pointer.
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      el.addEventListener('pointerenter', function () { reveal(el); });
      el.addEventListener('pointerleave', function () { unreveal(el); });
    }
  }

  function init() {
    var els = document.querySelectorAll('[data-tc-reveal]');
    if (!els.length) return;

    els.forEach(bind);

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, { threshold: 0.35 });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the Theme Editor injects/reloads a section.
  document.addEventListener('shopify:section:load', init);
})();
